import './styles.scss';
import icon_loading from '../../../assets/images/icon_loadingBlue.svg';

import { useState } from 'react';

import { motion } from 'framer-motion';
import { format, parse } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz/esm';
import { queryCache } from 'react-query';

import Title from '../../Title';
import Modal from '../../Modal';
import { Button } from '../../Button/Button';
import useAvalilableTimeData from '../../../hooks/useAvailableTimeData';
import { ReactSelect } from '../../ReactSelect/ReactSelect';
import useChangeExpertMutation from '../../../hooks/useChangeExpertMutation';
import { InputError } from '../../InputError/InputError';

interface Props {
  timeSlotID: number;
  onClose: () => void;
}

export const ChangeExpertModal: React.FC<Props> = ({ timeSlotID, onClose }) => {
  const { data: availableSlotsData, status: availableSlotsDataLoadingStatus } = useAvalilableTimeData(timeSlotID, undefined);
  const [selectedExpert, setSelectedExpert] = useState<undefined | string>(undefined);
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [selectedTime, setSelectedTime] = useState<string>('');
  const [mutate, { status: changeExpertMutationStatus }] = useChangeExpertMutation({
    onSuccess: () => {
      queryCache.invalidateQueries('adminExpertsScheduleData');
      queryCache.invalidateQueries('adminMembersData');
      queryCache.invalidateQueries('avalilableTImeData');
      setSelectedExpert(undefined);
      setSelectedDate('');
      setSelectedTime('');
      setTimeout(() => {
        onClose();
      }, 3000);
    },
  });

  // * Готовим съедобный массив данных для селекта эксперта
  const expertsForSelect = () => {
    if (availableSlotsData) {
      const experts = availableSlotsData.slots.map(expert => ({ value: expert.expert_id, label: expert.expert_name }));
      return experts;
    }
  };

  // * Готовим съедобный массив данных для селекта даты
  const datesForSelect = () => {
    if (availableSlotsData && selectedExpert) {
      const experts = availableSlotsData.slots.find(expert => expert.expert_id === selectedExpert);
      const dates = experts.slots.map(slot => ({ value: slot.date, label: slot.date }));
      return dates;
    }
  };

  // * Готовим съедобный массив данных для селекта времени
  const timesForSelect = () => {
    if (availableSlotsData && selectedExpert && selectedDate) {
      const experts = availableSlotsData.slots.find(expert => expert.expert_id === selectedExpert);
      const dates = experts.slots.find(slot => slot.date === selectedDate);
      const times = dates.time_slots.map(timeSlot => ({ value: timeSlot, label: timeSlot }));
      return times;
    }
  };

  if (availableSlotsDataLoadingStatus === 'loading') {
    return (
      <Modal className='changeExpertModal' onClose={onClose}>
        <div className='isLoading'>
          <motion.img src={icon_loading} initial={{ rotate: 0 }} animate={{ rotate: 360 }} transition={{ duration: 2, loop: Infinity, ease: 'linear' }} />
        </div>
      </Modal>
    );
  }

  return (
    <Modal className='changeExpertModal' onClose={onClose}>
      <Title>Перенести интервью на другого эксперта</Title>
      <ReactSelect placeholder='Имя эксперта' onChange={setSelectedExpert} options={expertsForSelect()} />
      <ReactSelect placeholder='Дата' onChange={setSelectedDate} isDisabled={!selectedExpert} options={selectedExpert ? datesForSelect() : undefined} />
      <ReactSelect
        placeholder='Время'
        onChange={setSelectedTime}
        isDisabled={!selectedExpert || !selectedDate}
        options={selectedExpert && selectedDate ? timesForSelect() : undefined}
      />
      <Button
        type='button'
        size='medium'
        width='330rem'
        color='blue'
        text='Применить'
        disabled={!selectedExpert || !selectedDate || !selectedTime}
        loading={changeExpertMutationStatus === 'loading' ? true : false}
        onClick={() =>
          mutate({
            timeSlotID,
            expertID: selectedExpert,
            dateTime: `${format(utcToZonedTime(parse(selectedDate, 'dd.MM.yyyy', new Date()), 'Europe/Moscow'), 'yyyy-MM-dd')} ${selectedTime}`,
          })
        }
      />

      <InputError className='success'>
        {changeExpertMutationStatus === 'success' ? (
          <>
            Расписание успешно изменено. <br /> Через 3 секунды это окно будет закрыто
          </>
        ) : (
          <>
            <br />
          </>
        )}
      </InputError>
    </Modal>
  );
};
